<div #timePickerContainer class="time-picker-container">
  <input
    #hourInput
    type="number"
    aria-label="hour"
    [ngModel]="zeroPadValue(hourVal)"
    #hourModel="ngModel"
    (input)="handleHourUpdate()"
    class="hour-input"
    data-test="hour-input"
  >
  :
  <input
    #minuteInput
    type="number"
    aria-label="minute"
    [ngModel]="zeroPadValue(minuteVal)"
    #minuteModel="ngModel"
    (input)="handleMinUpdate()"
    class="min-input"
    data-test="minute-input"
  >
  <mat-button-toggle-group
    aria-label="am or pm"
    [ngModel]="meridianVal"
    (ngModelChange)="handleMeridianUpdate($event)"
    class="meridian-input"
  >
    <mat-button-toggle
      tabindex="0"
      value="am"
      class="am-input"
      data-test="am-button"
    >am</mat-button-toggle>
    <mat-button-toggle
      tabindex="0"
      value="pm"
      class="pm-input"
      data-test="pm-button"
    >pm</mat-button-toggle>
  </mat-button-toggle-group>
</div>
